// extracted by mini-css-extract-plugin
module.exports = {"pymtDtl":"bankAccount_pymtDtl__1eOGQ"};